import styled from 'styled-components';

export const AboutUsWrapper = styled.div`
  position: relative;
  z-index: 2;
`;
